import React from 'react';
import { Event } from '../../model/event';
import { Avatar } from '../../components/Avatar/Avatar';
import { Icon } from '../../components/Icon/Icon';
import { isAdmin, useSelectedMembership } from '../../model/membership';
import { t } from '../../locales/translate';
import './Ownerships.css';
import { Ownership } from '../../model/ownerships';
import { Product } from '../../model/product';

interface Props {
  product: Event | Product;
  onAddCompany: () => void;
  onDeleteCompany: (company: Ownership) => void;
}

export function Ownerships({ product, onAddCompany, onDeleteCompany }: Props): JSX.Element {
  const membership = useSelectedMembership();

  return (
    <div className="ownerships">
      <div className="ownerships__companies">
        {product.ownerships && product.ownerships.length > 0 && (
          <ul className="ownerships__list">
            {product.ownerships.map((item) => {
              return (
                <li key={item.id} className="ownerships__list-item">
                  <Avatar
                    name={item.company.name || item.company.slug}
                    image={item.company.icon && item.company.icon.url}
                  ></Avatar>
                  <div className="ownerships__details">
                    {item.role && <div className="ownerships__role">{t.model.role[item.role as 'editor']}</div>}
                    <div className="ownerships__name">{item.company.name}</div>
                  </div>
                  {isAdmin(membership) && (
                    <div className="ownerships__delete">
                      <Icon name="trash--sm" onClick={() => onDeleteCompany(item)}></Icon>
                    </div>
                  )}
                </li>
              );
            })}
          </ul>
        )}
      </div>
      {isAdmin(membership) && (
        <div className="ownerships__add-new">
          <Icon name="plus" onClick={onAddCompany}></Icon>
        </div>
      )}
    </div>
  );
}
